export enum FilterType {
    Text,
    Date,
    Select,
    SearchableMultiselect,
    Autocomplete,
    ReadonlyInlineListFilter,
    DateRange
}